import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { ReactSortable } from "react-sortablejs";
import { snapshotToArray } from '../../helpers';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import DeleteDepartment from '../DeleteDepartment';
import CatItem from './CatItem';
import { useSelector } from 'react-redux';

const Category = (props) => {

    const [showChildren, setShowChildren] = useState(0);
    const [categories, setCategories] = useState(Object.values(props.categories));

    const toggleShow = () => {
        setShowChildren(showChildren ? false : true);
    }

    const setNewCategories = (list) => {
        list.forEach(function (category, index) {
            category.index = index;
        });
        setCategories(list);
        props.setCategories(props.slug, list);
    }

    const activities = useSelector(state => state.activities);

    const deleteFromList = (dept, category) => {
        let list = categories;
        let index = list.findIndex(cat => cat.slug === category);
        setCategories(list);
        props.hideParent();
    }

    return (
        <div>

            <ReactSortable list={Object.values(categories)} setList={setNewCategories}>
                {categories.sort((a, b) => a.index - b.index).map((item, key) => (
                    <CatItem item={item} key={key} department={props.department} deleteFromList={deleteFromList} />
                ))}
            </ReactSortable>

        </div>

    );
}

export default Category;
